var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderhistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79614 12.8748C6.79614 12.5296 7.07597 12.2498 7.42114 12.2498H11.9212C12.2663 12.2498 12.5462 12.5296 12.5462 12.8748C12.5462 13.2199 12.2663 13.4998 11.9212 13.4998H7.42114C7.07597 13.4998 6.79614 13.2199 6.79614 12.8748Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79529 9.53198C6.79529 9.18682 7.07511 8.90698 7.42029 8.90698H10.217C10.5621 8.90698 10.842 9.18682 10.842 9.53198C10.842 9.87715 10.5621 10.157 10.217 10.157H7.42029C7.07511 10.157 6.79529 9.87715 6.79529 9.53198Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.10869 3.56025C5.38523 2.15228 7.36512 1.6665 10.0332 1.6665C10.8054 1.6665 11.5178 1.70935 12.1597 1.79729C12.2897 1.8151 12.4109 1.8734 12.5059 1.96392L17.2309 6.46392C17.3269 6.5553 17.3913 6.67482 17.4149 6.80522C17.5819 7.72798 17.6582 8.79242 17.6582 9.99984C17.6582 12.9163 17.2259 15.0543 15.9646 16.443C14.6867 17.8498 12.7045 18.3332 10.0332 18.3332C7.36573 18.3332 5.38561 17.8498 4.10887 16.4427C2.84877 15.0541 2.4165 12.9164 2.4165 9.99984C2.4165 7.08717 2.84887 4.94977 4.10869 3.56025ZM5.03474 4.39985C4.10914 5.42074 3.6665 7.1375 3.6665 9.99984C3.6665 12.8666 4.10924 14.5831 5.03455 15.6028C5.94323 16.6041 7.45894 17.0832 10.0332 17.0832C12.6118 17.0832 14.1296 16.604 15.0393 15.6025C15.9654 14.5829 16.4082 12.8667 16.4082 9.99984C16.4082 8.93192 16.3457 8.01136 16.2188 7.22621L11.7923 3.01052C11.2666 2.94836 10.6788 2.9165 10.0332 2.9165C7.45955 2.9165 5.94362 3.3974 5.03474 4.39985Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6118 1.73535C11.957 1.73535 12.2368 2.01518 12.2368 2.36035V4.57785C12.2368 5.78077 13.2117 6.75535 14.4152 6.75535H16.8743C17.2195 6.75535 17.4993 7.03518 17.4993 7.38035C17.4993 7.72553 17.2195 8.00535 16.8743 8.00535H14.4152C12.5219 8.00535 10.9868 6.4716 10.9868 4.57785V2.36035C10.9868 2.01518 11.2666 1.73535 11.6118 1.73535Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderhistory);
export default __webpack_public_path__ + "static/media/orderhistory.ce8c38ca4a222df3a38099b4bd4ad8d0.svg";
export { ForwardRef as ReactComponent };